module.exports = "<div>\n        <h1 class=\"custom-h1\">\n            Hello World!\n        </h1>\n    </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/custom-app.vue
 ** module id = 82
 ** module chunks = 0
 **/